import { Component, OnInit } from '@angular/core';

@Component({ selector: 'app-green-campus', templateUrl: './green-campus.component.html', styleUrls: ['./green-campus.component.scss'] })
export class GreenCampusComponent implements OnInit { constructor() { } ngOnInit(): void { } }
